import { useEffect } from 'react'
import { Helmet } from 'react-helmet'

const ContactUs = () => {
  useEffect(() => {
    const script = document.createElement('script')
    script.type = 'text/javascript'
    script.src = '//js.hsforms.net/forms/v2.js'
    script.async = true
    document.body.appendChild(script)

    script.onload = () => {
      if (window.hbspt) {
        window.hbspt.forms.create({
          region: 'na1', // Change to your HubSpot region
          portalId: '1903707', // Replace with your HubSpot Portal ID
          formId: 'c707b9b1-6503-47ab-b652-5af0602cce2f', // Replace with your HubSpot Form ID
          target: '#hubspotForm' // The element ID where the form will be embedded
        })
      }
    }
  }, [])

  return (
        <>
            <Helmet>
                <title>Contact Us</title>
                <meta
                name="description"
                content="Discover the best time tracking software designed for remote employees. Boost productivity, manage time efficiently, and gain insights into your remote team's performance."
                />
                <meta name="keywords" content="time tracker, time tracking, remote employees, productivity, software, remote work" />
                <meta name="author" content="Pulse by Canned Head" />
                <meta name="robots" content="index, follow" />
                <meta property="og:title" content="Time Tracking Software For Remote Employees" />
                <meta property="og:description" content="Discover the best time tracking software designed for remote employees. Boost productivity, manage time efficiently, and gain insights into your remote team's performance." />
                <meta property="og:image" content="https://example.com/image.jpg" />
                <meta property="og:url" content="https://example.com/time-tracking-software" />
                <meta property="og:type" content="website" />
            </Helmet>
            <div className='contactUs container-fluid'>
                <div className='container'>
                    <div className='row justify-content-center'>
                        <div className='col-12 col-md-6'>
                            <h1>Contact Us</h1>
                            <p>Got any questions about our product or aling on our platform? We&apos;re here to help.</p>
                        </div>
                    </div>
                    <div className='row justify-content-center'>
                        <div className='col-12 col-md-6 mx-auto' id="hubspotForm"></div>
                    </div>
                </div>
            </div>
        </>
  )
}

export default ContactUs
